module.exports = __webpack_public_path__ + "img/cmWCAfoy.db43e7c8.svg";